import { Maybe } from '@graphql-tools/utils'
import { AppFeatures } from '@/experimentation'
import { GuildSale } from '@/services/SaleService'

/**
 * This is checking to see if the currently active Sale is the Black Friday sale configured in Contentful here
 * https://app.contentful.com/spaces/4jbwlym6m4be/environments/master/entries/2POg7wu58Fd6Wo3hxByhna?focusedField=name&focusedLocale=en
 * @param sale
 * @param experiments
 */
export const isDavidTicketsOfferedWithAnnualPlans = (
  sale: Maybe<GuildSale>,
  experiments: Record<keyof AppFeatures, unknown>,
  /** optional selected tier to allow premium-only variation */
  selectedTier?: string,
) => {
  // Always show during the specific sale
  if (sale?.id === '2POg7wu58Fd6Wo3hxByhna') return true

  const rawVariant = experiments['david-tickets-annual-plans-updated']

  // Legacy behavior: experiment was a boolean flag. True => show for all annual plans.
  if (typeof rawVariant === 'boolean') return rawVariant

  const variant = typeof rawVariant === 'string' ? rawVariant : 'control'

  // control => do not show
  if (variant === 'control') return false

  // variation_1 => show on all annual plans
  if (variant === 'variation_1') return true

  // variation_2 => show only on Premium annual
  if (variant === 'variation_2') {
    return selectedTier === 'premium'
  }

  // default fallback: do not show
  return false
}
